exports = module.exports = require("../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tutorial-page ion-toolbar {\n  --background: transparent;\n  --border-color: transparent;\n}\n\n.tutorial-page .swiper-slide {\n  display: block;\n}\n\n.tutorial-page .slide-title {\n  margin-top: 2.8rem;\n}\n\n.tutorial-page .slide-image {\n  max-height: 50%;\n  max-width: 60%;\n  margin: 36px 0;\n}\n\n.tutorial-page b {\n  font-weight: 500;\n}\n\n.tutorial-page p {\n  padding: 0 40px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #60646B;\n}\n\n.tutorial-page p b {\n  color: #000000;\n}\n", ""]);

// exports
